import type { ReactNode } from 'react';

import { Text } from '../../Text';
import {
  MINIMUM_MATCH_LENGTH,
  getTokenizedWordRegex,
  matchSubstring,
} from '../utils/search';

export function getMatchedWords(
  match?: string,
  children?: ReactNode
): ReactNode {
  if (
    !(
      match &&
      typeof children === 'string' &&
      match.length > MINIMUM_MATCH_LENGTH
    )
  ) {
    return children;
  }

  return children
    .split(getTokenizedWordRegex(match))
    .map((substring, index) => {
      if (matchSubstring(match, substring)) {
        return (
          <Text weight="bold" key={`${substring}-match-${index}`}>
            {substring}
          </Text>
        );
      }

      return substring;
    });
}
